import request from '@/utils/request';

export function getChildrenDayInfo() {
  return request({
    url: '/Marketing/childrenDay2021',
  });
}

export function updateChildrenDayDrawChance() {
  return request({
    url: '/Marketing/childrenDay2021Share',
    method: 'POST',
    silentRequest: true,
  });
}

export function getChildrenDayPrizeDrawResult() {
  return request({
    url: '/Marketing/childrenDay2021Draw',
    method: 'POST',
    silentRequest: true,
  });
}

export function getChildrenDayPrizeDrawList() {
  return request({
    url: '/Marketing/childrenDay2021Prize',
  });
}
